var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-panel',{attrs:{"stretch":_vm.$attrs.stretch,"min-width":215,"min-height":60}},[_c('spot-summary-content',_vm._g(_vm._b({},'spot-summary-content',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }